import React, { useState } from 'react';
import { format } from 'date-fns';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { HolidayBookingForm } from './HolidayBookingForm';

const BookingSuccess = ({ booked, onClose }) => (
  <div className="text-center py-6" data-testid="booking-success">
    <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto mb-4" />
    <h3 className="text-xl font-bold text-gray-900 mb-2">Request received</h3>
    <p className="text-gray-600 mb-1">Requested date: <strong>{format(booked.date, 'EEEE, MMMM d, yyyy')}</strong></p>
    <p className="text-gray-600 mb-6">{booked.message}</p>
    <Button onClick={onClose} className="bg-gray-900 hover:bg-black text-white" data-testid="booking-success-close">Done</Button>
  </div>
);

export const HolidayBookingDialog = ({ open, onOpenChange }) => {
  const [booked, setBooked] = useState(null);
  const handleOpenChange = (next) => {
    if (!next) setBooked(null);
    onOpenChange(next);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto z-[150]" data-testid="holiday-booking-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center text-2xl">
            <Sparkles className="w-5 h-5 mr-2 text-yellow-500" />
            Book Your Christmas Lights
          </DialogTitle>
          <DialogDescription>Pick the day you'd like us to install. We'll call to confirm the time and give you a free design estimate.</DialogDescription>
        </DialogHeader>
        {booked ? <BookingSuccess booked={booked} onClose={() => handleOpenChange(false)} /> : <HolidayBookingForm onBooked={setBooked} />}
      </DialogContent>
    </Dialog>
  );
};
